import React from "react";
import PropTypes from "prop-types";
import { TimelineMinimap } from "../../../components/TimelineMinimap";
import { List } from "semantic-ui-react";

export const PriceElementsList = ({ children, state, pricings, ...rest }) => {
    return <div className="price-element-list" {...rest}>
        <TimelineMinimap priceList={state} elements={pricings} />
        <List>
            {children}
        </List>
    </div>
}

PriceElementsList.propTypes = {
    children: PropTypes.node,
    state: PropTypes.any,
    pricings: PropTypes.any
};
